// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"245":"d3d22d92e3a9d7247a5f","452":"928685986d4b71fc6bed","453":"c4efa3964e1784fa1b67","471":"09533d64cb90766b3352","551":"1cc319601db4fffc63af"}[chunkId] + ".js";
};